import * as React from "react";

const SvgTextToVideo = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      fill="currentColor"
      d="M12.6667 6.00008L11.8333 4.16675L9.99999 3.33341L11.8333 2.50008L12.6667 0.666748L13.5 2.50008L15.3333 3.33341L13.5 4.16675L12.6667 6.00008ZM12.6667 15.3334L11.8333 13.5001L9.99999 12.6667L11.8333 11.8334L12.6667 10.0001L13.5 11.8334L15.3333 12.6667L13.5 13.5001L12.6667 15.3334ZM5.99999 13.3334L4.33332 9.66675L0.666656 8.00008L4.33332 6.33341L5.99999 2.66675L7.66666 6.33341L11.3333 8.00008L7.66666 9.66675L5.99999 13.3334ZM5.99999 10.1001L6.66666 8.66675L8.09999 8.00008L6.66666 7.33341L5.99999 5.90008L5.33332 7.33341L3.89999 8.00008L5.33332 8.66675L5.99999 10.1001Z"
    />
  </svg>
);
export default SvgTextToVideo;
